import { Link, NavLink } from '@remix-run/react'
import React from 'react'
import { Icon } from '#app/components/ui/icon.tsx'
import { cn } from '#app/utils/misc.tsx'

const partners = [
	'/img/partners/rp-group.png',
	'/img/partners/bordorvic.png',
	'/img/partners/vertical.png',
]

const footerLinks = [
	{ to: '/competitions', label: 'Competitions' },
	{ to: '/communities', label: 'Communities' },
	{ to: '/about', label: 'About' },
	{ to: '/privacy', label: 'Privacy Policy' },
]

const Footer = () => {
	return (
		<footer className="bg-background-dark-foreground py-12 text-white/90">
			<div className="container mx-auto space-y-12 px-4 md:space-y-24">
				{/* <div className="space-y-6 md:space-y-8">
					<h6 className="text-h6 uppercase text-white/80 tracking-wider">Our partners</h6>

					<div className="flex flex-wrap items-center gap-6">
						{partners.map((partner, index) => (
							<div
								className="flex h-16 w-32 items-center justify-center rounded-md bg-background-dark/40 p-3 sm:h-20 sm:w-40"
								key={partner}
							>
								<img
									className={cn('h-full w-full object-cover', {
										'object-contain': index === 0,
									})}
									src={partner}
									alt="Partner logo"
								/>
							</div>
						))}
					</div>
				</div> */}

				<ul className="flex items-center gap-5">
					<li>
						<Link
							to="https://www.facebook.com/profile.php?id=100095117494505"
							target="_blank"
							className="flex h-10 w-10 items-center justify-center rounded-full bg-background-dark/40 text-white/80 transition-colors hover:bg-background-dark hover:text-white"
						>
							<Icon name="facebook" className="size-5" />
						</Link>
					</li>
					<li>
						<Link
							to="https://x.com/7evensportsgh"
							target="_blank"
							className="flex h-10 w-10 items-center justify-center rounded-full bg-background-dark/40 text-white/80 transition-colors hover:bg-background-dark hover:text-white"
						>
							<Icon name="twitter" className="size-5" />
						</Link>
					</li>
					<li>
						<Link
							to="https://www.instagram.com/7evensportsgh"
							target="_blank"
							className="flex h-10 w-10 items-center justify-center rounded-full bg-background-dark/40 text-white/80 transition-colors hover:bg-background-dark hover:text-white"
						>
							<Icon name="instagram" className="size-5" />
						</Link>
					</li>
					<li>
						<Link
							to="https://www.youtube.com/channel/UCYyRCEnlDhHohhZXdALf6Sg"
							target="_blank"
							className="flex h-10 w-10 items-center justify-center rounded-full bg-background-dark/40 text-white/80 transition-colors hover:bg-background-dark hover:text-white"
						>
							<Icon name="youtube" className="size-5" />
						</Link>
					</li>
					<li>
						<Link
							to="https://www.tiktok.com/@7evensportsgh"
							target="_blank"
							className="flex h-10 w-10 items-center justify-center rounded-full bg-background-dark/40 text-white/80 transition-colors hover:bg-background-dark hover:text-white"
						>
							<Icon name="tiktok" className="size-5" />
						</Link>
					</li>
					<li>
						<Link
							to="https://www.twitch.tv/7evensportsgh"
							target="_blank"
							className="flex h-10 w-10 items-center justify-center rounded-full bg-background-dark/40 text-white/80 transition-colors hover:bg-background-dark hover:text-white"
						>
							<Icon name="twitch" className="size-5" />
						</Link>
					</li>
				</ul>

				<div className="flex flex-col-reverse gap-12 space-y-8 md:flex-row md:items-center md:justify-between md:gap-0 md:space-y-0">
					<p className="text-center text-sm text-white/60 md:text-left">
						Copyright {new Date().getFullYear()}. All rights reserved.
					</p>

					<ul className="flex flex-col items-center space-y-4 font-medium md:flex-row md:space-y-0">
						{footerLinks.map((link, index) => (
							<li
								key={link.to}
								className={cn('flex items-center justify-center', {
									'md:px-6': index < footerLinks.length - 1,
									'md:pl-6': index === footerLinks.length - 1,
								})}
							>
								<NavLink
									to={link.to}
									className={({ isActive }) =>
										isActive
											? 'text-primary'
											: 'text-white/70 transition-colors duration-150 ease-in-out hover:text-white'
									}
								>
									{link.label}
								</NavLink>
							</li>
						))}
					</ul>
				</div>
			</div>
		</footer>
	)
}

export default Footer
